
import { useState, useRef } from "react";
import Config from "../../Config";

import check from "../../check.png";
import edit from "../../edit.png";
import trash from "../../trash.png";

 

import FreeDaysNew from "./FreeDaysNew";
import Calendar from "../../calendar/Calendar";

import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";

import PlTitle from "../../elements/PlTitle";
import MenuTable from "../../helpers/MenuTable";



function FreeDays(props)
{
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    const [tab, setTab] = useState(null);


    const tabRef = useRef(0);


    const getData = () => {
       
 
        props.mainView.setProgress(-2);

        var req = {
        
        };

        fetch( Config.url + '/rest_v1,days', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res);              
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }


    const goDeleteDays = (id) => {
       
 
        props.mainView.setProgress(-2);

        var req = {
            id:id
        };

        fetch( Config.url + '/rest_v1,days_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                       props.mainView.showDialog( "Sukces",  "Pozycja została usunięta" , "ok" , null);  
                       getData();   
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }



    const goDelete = (e) => {

        var id = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć wybraną pozycje?", "yesno", (option)=>{
          
                        ///--------
                        if(option == "yes") goDeleteDays(id);
                        //--------
        } );
    }
  

    const dayAdded = (e) => {
        getData();
    }


    const clickOnDay = (date,title) => {

        props.mainView.showDialog( date, title , "ok" , null);  
    }



    if(tab == null)
    {
        setTab([]);
        getData(); 
        return (
            <div></div>
        );        
    }

    if(tab._sys_ == undefined) //no correct response..
    {
        return (
            <div></div>
        );   
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        getData();
    }
 


    var daysReview = new Array();

    for(var k=0; k<tab.result.length; k++)
    {
        daysReview.push({
            date: tab.result[k].dzien,
            title: tab.result[k].powod,
            className: "selected",
        });
    }



    return (
        <div className="view_content">
 


          

            <div className="bg_center">   

            <div className="table_widget">
                <FreeDaysNew userData={props.userData} mainView={props.mainView}  dayAdded={dayAdded} />
            </div>

                      
            <Calendar tab={daysReview} clickOnDay={clickOnDay} />
                
                <br/>&nbsp; <br/>
                     
            <div className="table_widget">
                    <Csv tabRef={tabRef} />
                  
                    <Print tabRef={tabRef} />
            </div>                     
            <table className="table"  ref={tabRef}>
                        <thead>
                            <tr className="header">
                                <td className="td_left">LP</td>
                                <td>Dzień</td>
                                <td className="td_right">Opis</td>                          
                                <td className="td_option"> </td>
                            </tr>
                        </thead>
                        <tbody>
                         

                            {
                                tab.result.map(  (item, ix) => {

                                var ac = '-';
                                if(item.is_active == '1') ac = <img src={check}  />

                                var rowStyle = " row ";
                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                 return (
                                        <tr className={rowStyle} >
                                            <td className="gocenter">{ (ix + 1) }</td>
                                            <td className="gocenter">{item.dzien}</td>
                                            <td >{item.powod}</td>
                                                                 
                                            <MenuTable>
                                                <ul>
                                                    <li onClick={goDelete} v="delete" id={item.id} >usuń</li>
                                                </ul>
                                            </MenuTable>
                                        </tr>
                                        )
                                } )
                            }

                        </tbody>
                    </table>

            </div>

        </div>
    )
}


export default FreeDays;